import { render, staticRenderFns } from "./MovementDetail.vue?vue&type=template&id=c5763fce&scoped=true&"
import script from "./MovementDetail.vue?vue&type=script&lang=js&"
export * from "./MovementDetail.vue?vue&type=script&lang=js&"
import style0 from "./MovementDetail.vue?vue&type=style&index=0&id=c5763fce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5763fce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCol,VContainer,VRow,VTooltip})
